import Axios from "axios";
import { baseURL } from "../constants";

export const projectsAndDepartmentByIp = (people_id: string, token: string) => {
  return Axios.get(`${baseURL}peopleProjects/projectsAndDepartmentByIp/${people_id}`, {
    headers: {
      Authorization: token,
    },
  })
    .then(({ status, data }) => {
      if (status !== 200) {
        return Promise.reject(status);
      } else {
        return Promise.resolve(data);
      }
    })
    .catch((err) => Promise.reject(err));
};
